<div class="main-container">
    <div class="top-container header">
        <h2 appLocalizationPopupDirective localizationCode="Documents">{{ 'Documents' | translate: {Default: "Documents"} }}</h2>
    </div>

    <app-documents-tree-view 
        *ngIf="selectedView == 'treeView'"
        [employeeID]="employeeID"
        (editAction)="openDocumentEditDialog($event)"
        (deleteAction)="openConfirmDeleteDialog($event)"
        (viewAction)="download($event)"
        (moveAction)="moveItem($event)"
        (downloadAction)="download($event)"
        (showCreateNewDirectoryForm)="openDirectoryFormDialog($event)"
        (showDocumentUploadDialog)="openDocumentUploadDialog($event)"
        [refreshView]="refreshView"
        [focusElementId]="newElementId"
    ></app-documents-tree-view>
</div>